import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import ChevronDown from "../../icons/chevronDownIcon";
import styles from "./style.module.css";

const NavItem = ({ page }) => {
  const location = useLocation();
  // Check if current URL path contains the page link to determine if this nav item or its children are active
  const isInclude = location.pathname.includes(page.link);
  const [isFirstChildActive, setIsFirstChildActive] = useState(false);

  useEffect(() => {
    if (page?.children && isInclude) {
      if (page.link === location.pathname) {
        setIsFirstChildActive(true);
      } else {
        setIsFirstChildActive(false);
      }
    }
  }, [page, isInclude, location]);

  return (
    <li>
      <NavLink
        to={page.link}
        className={({ isActive }) => (isActive ? `${styles.active}` : "")}
      >
        {page.icon && <page.icon className={styles.nav_link_icon} />}
        <span className={styles.nav_link_title}>{page.title}</span>
        <span className={styles.line}></span>
        {page?.children && <ChevronDown className={styles.down_icon} />}
      </NavLink>
      {page?.children &&
        (isInclude ? (
          <ul>
            {page.children.map((child, index) => (
              <li key={index}>
                {child.link ? (
                  <NavLink
                    to={`${page.link}${child.link}`}
                    className={({ isActive }) =>
                      isActive || (index === 0 && isFirstChildActive)
                        ? `${styles.sub_nav_link_active}`
                        : ""
                    }
                  >
                    {child.title}
                  </NavLink>
                ) : (
                  <button type="button" onClick={child.onClick}>
                    {child.title}
                  </button>
                )}
              </li>
            ))}
          </ul>
        ) : (
          ""
        ))}
    </li>
  );
};

export default NavItem;
